import { getSessions } from 'core_main/api/sessions';
import { PublicCallback } from 'globals/types';
import { maybeFetchCurrentTrackingToken } from 'core_main/api/tracking';
import { GetConversationsParameters } from './types';
import { createGetConversationsCallbackResponse } from './helpers';

export const getConversations = (
  parameters: GetConversationsParameters,
  cb?: PublicCallback,
) => {
  return maybeFetchCurrentTrackingToken()
    .then(() => {
      return getSessions(parameters);
    })
    .then((response) => {
      const callbackResponse = createGetConversationsCallbackResponse(response);

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }

      return response;
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      console.error('Failed to get conversations for customer:', error);
    });
};
